import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import Display from './Display';
import ClientProvider from './client';
export default createDemo(import.meta.url, Display, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/flexbox/demos/display/Display.tsx",
    "fileName": "Display.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\n\nexport default function Display() {\n  return (\n    <div style={{ width: '100%' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box\n        sx={[\n          (theme) => ({\n            display: 'flex',\n            m: 1,\n            p: 1,\n            bgcolor: '#fff',\n            color: 'grey.800',\n            border: '1px solid',\n            borderColor: 'grey.300',\n            borderRadius: 2,\n            fontSize: '0.875rem',\n            fontWeight: '700',\n            ...theme.applyStyles('dark', {\n              bgcolor: '#101010',\n              color: 'grey.300',\n              borderColor: 'grey.800',\n            }),\n          }),\n        ]}\n      >\n        {\"I'm a flexbox container that uses flex!\"}\n      </Box>\n      <Box\n        sx={(theme) => ({\n          display: 'inline-flex',\n          m: 1,\n          p: 1,\n          bgcolor: '#fff',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        {\"I'm a flexbox container that uses inline-flex!\"}\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 52,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\n\nexport default function Display() {\n  return (\n    <div style={{ width: '100%' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Box\n        sx={[\n          (theme) => ({\n            display: 'flex',\n            m: 1,\n            p: 1,\n            bgcolor: '#fff',\n            color: 'grey.800',\n            border: '1px solid',\n            borderColor: 'grey.300',\n            borderRadius: 2,\n            fontSize: '0.875rem',\n            fontWeight: '700',\n            ...theme.applyStyles('dark', {\n              bgcolor: '#101010',\n              color: 'grey.300',\n              borderColor: 'grey.800',\n            }),\n          }),\n        ]}\n      >\n        {\"I'm a flexbox container that uses flex!\"}\n      </Box>\n      <Box\n        sx={(theme) => ({\n          display: 'inline-flex',\n          m: 1,\n          p: 1,\n          bgcolor: '#fff',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        {\"I'm a flexbox container that uses inline-flex!\"}\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "totalLines": 52,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
